import {
  BookingConfig,
  BookingConfigEnum,
  ConfigTypeEnum,
} from '../../components/BookingWidget/bookingSteps.interface';
import authHelper from './auth.helper';

const isWhitelabel = (bookingConfigData: BookingConfig): boolean =>
  !authHelper().isAgent() &&
  bookingConfigData[BookingConfigEnum.Type] === ConfigTypeEnum.WHITE_LABEL;

export default isWhitelabel;
